import { useTranslation } from "react-i18next"
import { SwitchToChromeDialog } from "./SwitchToChromeDialog"

type HealingUnavailableDialogProps = {
	onDismiss?: () => void
}

export const HealingUnavailableDialog = ({ onDismiss }: HealingUnavailableDialogProps) => {
	const { t } = useTranslation("components")
	return (
		<SwitchToChromeDialog
			onDismiss={onDismiss}
			bodyText={t("healingUnavailableDialog.bodyText")}
			trackingViewName="healing_unavailable_dialog"
		/>
	)
}
